const query = {
    baseURL: 'https://command.dttsynergy.com', // https://deloittesynergy.service-now.com
    path: {
        cityService: '/api/now/table/u_city_service',
        file: '/api/now/attachment/file',
        incident: '/api/now/table/incident',
        synergyCategory: '/api/now/table/u_synergy_category_service',
        token: '/oauth_token.do',
        user: '/api/now/table/sys_user',
    }
}

export default query;